<template>
  <template v-if="sidebarComponents.length === 0">
    <section
      v-if="variants.v1 === variant"
      class="n-section-primary"
      :style="`background-color: var(--c-${vars.backgroundColor})`"
    >
      <div class="tw-w-full md:tw-px-10">
        <div class="tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center tw-gap-7">
          <div class="md:tw-w-full">
            <div
              class="tw-mb-5 tw-flex tw-w-[98%] tw-flex-row tw-flex-wrap tw-items-center tw-justify-between tw-gap-y-2 md:tw-mb-8"
            >
              <div v-html="vars.titleHtml" class="tw-flex tw-flex-row tw-flex-wrap tw-gap-x-4 tw-text-black"></div>
              <nuxt-link
                v-if="vars.buttonTypeText"
                :to="vars.buttonLinkUrl"
                :class="`n-${vars.buttonTypeText} tw-hidden lg:tw-block`"
                :external="true"
              >
                {{ vars.buttonLabelText }}</nuxt-link
              >
            </div>
            <Swiper
              effect="fade"
              :clickable="true"
              :loop="true"
              :modules="[SwiperGrid]"
              :watch-overflow="true"
              @slideChange="onSlideChange"
              :breakpoints="{
                320: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 2,
                },
                1024: {
                  slidesPerView: 3,
                },
                1280: {
                  slidesPerView: 4,
                },
              }"
              :spaceBetween="10"
              @swiper="onSwiper"
              class="tw-max-w-xs md:tw-max-w-none"
            >
              <SwiperSlide
                v-for="(guide, index) in guides"
                :key="`ourguide-guide-${index}`"
                class="!tw-flex !tw-h-auto tw-max-w-none tw-items-center tw-justify-center tw-px-2"
              >
                <guide-card :component="component" :guide="guide" />
              </SwiperSlide>
              <div class="controls !tw-mt-8">
                <div
                  data-w-id="080a9ca2-7a2d-2ca3-3b22-f42b27569daf"
                  class="slide-left-arrow w-slider-arrow-left"
                  :isDisabled="!canPaginateBack"
                  @click="() => swiper.slidePrev()"
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M16.011 3.49956C16.1418 3.6335 16.2151 3.81332 16.2151 4.00056C16.2151 4.18781 16.1418 4.36762 16.011 4.50156L8.70149 12.0001L16.011 19.4971C16.1418 19.631 16.2151 19.8108 16.2151 19.9981C16.2151 20.1853 16.1418 20.3651 16.011 20.4991C15.9474 20.5644 15.8714 20.6163 15.7874 20.6517C15.7034 20.6872 15.6132 20.7054 15.522 20.7054C15.4308 20.7054 15.3406 20.6872 15.2566 20.6517C15.1726 20.6163 15.0966 20.5644 15.033 20.4991L7.25999 12.5236C7.12347 12.3835 7.04706 12.1957 7.04706 12.0001C7.04706 11.8045 7.12347 11.6166 7.25999 11.4766L15.033 3.50106C15.0966 3.43575 15.1726 3.38383 15.2566 3.34839C15.3406 3.31294 15.4308 3.29468 15.522 3.29468C15.6132 3.29468 15.7034 3.31294 15.7874 3.34839C15.8714 3.38383 15.9474 3.43575 16.011 3.50106V3.49956Z"
                      fill="#6EADAB"
                    />
                  </svg>
                  <div class="slide-circle slider-circle-transform"></div>
                </div>
                <div
                  data-w-id="080a9ca2-7a2d-2ca3-3b22-f42b27569db1"
                  class="slide-right-arrow w-slider-arrow-right"
                  :isDisabled="!canPaginateNext"
                  @click="() => swiper.slideNext()"
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M7.98901 3.49956C7.85817 3.6335 7.78491 3.81332 7.78491 4.00056C7.78491 4.18781 7.85817 4.36762 7.98901 4.50156L15.2985 12.0001L7.98901 19.4971C7.85817 19.631 7.78491 19.8108 7.78491 19.9981C7.78491 20.1853 7.85817 20.3651 7.98901 20.4991C8.0526 20.5644 8.12864 20.6163 8.21263 20.6517C8.29661 20.6872 8.38685 20.7054 8.47801 20.7054C8.56917 20.7054 8.65941 20.6872 8.74339 20.6517C8.82738 20.6163 8.90342 20.5644 8.96701 20.4991L16.74 12.5236C16.8765 12.3835 16.9529 12.1957 16.9529 12.0001C16.9529 11.8045 16.8765 11.6166 16.74 11.4766L8.96701 3.50106C8.90342 3.43575 8.82738 3.38383 8.74339 3.34839C8.65941 3.31294 8.56917 3.29468 8.47801 3.29468C8.38685 3.29468 8.29661 3.31294 8.21263 3.34839C8.12864 3.38383 8.0526 3.43575 7.98901 3.50106V3.49956Z"
                      fill="#6EADAB"
                    />
                  </svg>
                  <div class="slide-circle right"></div>
                </div>
              </div>
            </Swiper>
          </div>
          <nuxt-link
            v-if="vars.buttonTypeText"
            :to="vars.buttonLinkUrl"
            :class="`n-${vars.buttonTypeText} lg:tw-hidden`"
            :external="true"
          >
            {{ vars.buttonLabelText }}</nuxt-link
          >
        </div>
      </div>
    </section>

    <section
      v-else-if="variants.v2 === variant"
      class="n-section-primary"
      :style="`background-color: var(--c-${vars.backgroundColor})`"
    >
      <div class="tw-flex tw-w-full tw-flex-col tw-items-center">
        <!-- Başlık -->
        <div v-html="vars.titleHtml" class="tw-mb-6 tw-w-full tw-text-center lg:tw-mb-12"></div>

        <!-- Masaüstü Görünümü: Grid Yapısı -->
        <div
          class="tw-hidden tw-flex-wrap tw-items-center tw-justify-center tw-gap-x-4 tw-gap-y-6 xl:tw-flex xl:tw-w-full"
        >
          <div
            v-for="guide in guides"
            class="n-card tw-group tw-relative tw-col-span-3 tw-flex tw-min-h-[600px] tw-w-full tw-flex-[24%] tw-flex-grow-0 tw-cursor-pointer tw-flex-col tw-overflow-hidden tw-rounded-[var(--c-rounded)] tw-bg-white tw-text-start tw-transition-all tw-duration-500 hover:tw-bg-[var(--c-input)] xl:tw-h-auto xl:tw-min-h-[300px]"
            @click="handleGuideClick(guide)"
            style="border-radius: var(--rounded)"
          >
            <!-- Resim Alanı -->
            <div class="tw-relative">
              <div class="tw-relative tw-p-4">
                <library-image
                  v-if="guide.photo"
                  :src="guide.photo"
                  :is-ratio-free="true"
                  image-class="tw-h-full tw-w-full tw-object-cover"
                  style="border-radius: var(--rounded)"
                />
              </div>
            </div>
            <!-- Kart Bilgi Alanı: Başlık ve Buton -->
            <div
              class="tw-flex tw-h-full tw-flex-col tw-items-start tw-justify-end tw-gap-4 tw-px-4 tw-py-6 tw-text-left"
            >
              <h5 class="tw-mb-2 tw-line-clamp-2 tw-h-16 tw-overflow-hidden tw-text-[--c-secondary]">
                {{ guide.title }}
              </h5>
              <nuxt-link
                :to="guide.button_link ? guide.button_link : ''"
                :external="true"
                target="_blank"
                class="n-secondary n-link"
                @click.prevent="!guide.button_link && handleGuideClick(guide)"
              >
                VIEW THIS GUIDE
              </nuxt-link>
            </div>
          </div>
        </div>

        <!-- Mobil ve Tablet Görünümü: Swiper Slider -->
        <div class="tw-w-full xl:tw-hidden">
          <Swiper
            @swiper="onSwiper"
            @slideChange="onSlideChange"
            :pagination="false"
            :slides-per-view="3"
            :space-between="24"
            :clickable="true"
            :breakpoints="{
              320: { slidesPerView: 1, spaceBetween: 20 },
              768: { slidesPerView: 2, spaceBetween: 24 },
              1024: { slidesPerView: 3, spaceBetween: 24 },
            }"
            class="tw-w-full"
          >
            <SwiperSlide v-for="(guide, index) in guides" :key="`ourguide-guide-${index}`" class="!tw-flex !tw-h-auto">
              <div
                class="n-card tw-group tw-relative tw-flex tw-min-h-[600px] tw-w-full tw-cursor-pointer tw-flex-col tw-overflow-hidden tw-rounded-[var(--c-rounded)] tw-bg-white tw-text-start tw-transition-all tw-duration-500 hover:tw-bg-[var(--c-input)] xl:tw-h-auto xl:tw-min-h-[300px]"
                @click="handleGuideClick(guide)"
                style="border-radius: var(--rounded)"
              >
                <!-- Resim Alanı -->
                <div class="tw-relative">
                  <div class="tw-relative tw-p-4">
                    <library-image
                      v-if="guide.photo"
                      :src="guide.photo"
                      :is-ratio-free="true"
                      image-class="tw-h-full tw-w-full tw-object-cover"
                      style="border-radius: var(--rounded)"
                    />
                  </div>
                </div>
                <!-- Kart Bilgi Alanı: Başlık ve Buton -->
                <div
                  class="tw-flex tw-h-full tw-flex-col tw-items-start tw-justify-end tw-gap-4 tw-px-4 tw-py-6 tw-text-left"
                >
                  <h5 class="tw-mb-2 tw-line-clamp-2 tw-h-16 tw-overflow-hidden tw-text-[--c-secondary]">
                    {{ guide.title }}
                  </h5>
                  <nuxt-link
                    :to="guide.button_link ? guide.button_link : ''"
                    :external="true"
                    target="_blank"
                    class="n-secondary n-link"
                    @click.prevent="!guide.button_link && handleGuideClick(guide)"
                  >
                    VIEW THIS GUIDE
                  </nuxt-link>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
          <!-- Slider Pagination (mobil versiyon için) -->
          <div class="tw-mt-10 xl:tw-hidden">
            <LibrarySliderPagination
              :swiper="swiper"
              variant="v6"
              :canPaginateBack="canPaginateBack"
              :canPaginateNext="canPaginateNext"
            />
          </div>
        </div>
      </div>

      <popup v-if="selectedGuide && popupConfig.isActive" :config="popupConfig" custom-width="90%">
        <template #content>
          <div class="tw-w-full tw-bg-white">
            <div
              class="tw-mx-auto tw-flex tw-w-full tw-flex-col md:tw-w-[80%] lg:tw-w-full lg:tw-flex-row"
              style="border-radius: var(--rounded)"
            >
              <div class="tw-w-full tw-overflow-hidden lg:tw-max-w-[465px]" style="border-radius: var(--rounded)">
                <LibraryImage
                  :w-ratio="1"
                  :h-ratio="1.5"
                  :src="selectedGuide.photo || selectedGuide.popup_cover"
                  style="border-radius: var(--rounded)"
                />
              </div>
              <div class="tw-flex tw-w-full tw-py-6 md:tw-py-10 lg:tw-px-10 lg:tw-py-0 xl:tw-px-20">
                <h2 class="n-title-primary">{{ selectedGuide.popup_title }}</h2>
                <!-- form alanı -->
                <library-form
                  v-if="selectedGuide.guide"
                  :form="form"
                  version="v2"
                  :component="component"
                ></library-form>
              </div>
            </div>
          </div>
        </template>
      </popup>
    </section>

    <section
      v-else-if="variants.v3 === variant"
      class="n-section-primary"
      :style="`background-color: var(--c-${vars.backgroundColor})`"
    >
      <div class="tw-flex tw-w-full tw-flex-col tw-items-center">
        <!-- Başlık -->
        <div class="tw-mb-6 tw-w-full tw-text-center lg:tw-mb-12">
          <h2 class="n-title-primary">{{ vars.titleText }}</h2>
        </div>

        <!-- Mobil ve Tablet Görünümü: Swiper Slider -->
        <div class="tw-w-full">
          <Swiper
            @swiper="onSwiper"
            @slideChange="onSlideChange"
            :pagination="false"
            :slides-per-view="3"
            :space-between="24"
            :clickable="true"
            :breakpoints="{
              320: { slidesPerView: 1, spaceBetween: 20 },
              768: { slidesPerView: 3, spaceBetween: 24 },
              1024: { slidesPerView: 4, spaceBetween: 24 },
            }"
            class="tw-w-full"
          >
            <SwiperSlide v-for="(guide, index) in guides" :key="`ourguide-guide-${index}`" class="!tw-flex !tw-h-auto">
              <MotionGroup is="div" preset="slideVisibleBottom" class="tw-w-full">
                <div
                  class="n-card tw-group tw-relative tw-flex tw-min-h-[600px] tw-w-full tw-cursor-pointer tw-flex-col tw-overflow-hidden tw-rounded-[var(--c-rounded)] tw-bg-white tw-text-start tw-transition-all tw-duration-500 hover:tw-bg-[var(--c-input)] xl:tw-h-auto xl:tw-min-h-[300px]"
                  @click="handleGuideClick(guide)"
                  style="border-radius: var(--rounded)"
                >
                  <!-- Resim Alanı -->
                  <div class="tw-relative">
                    <div class="tw-relative tw-p-4">
                      <library-image
                        v-if="guide.photo"
                        :src="guide.photo"
                        :h-ratio="16"
                        :w-ratio="10"
                        image-class="tw-h-full tw-w-full tw-object-cover"
                        style="border-radius: var(--rounded)"
                      />
                    </div>
                  </div>
                  <!-- Kart Bilgi Alanı: Başlık ve Buton -->
                  <div
                    class="tw-flex tw-h-full tw-flex-col tw-items-start tw-justify-end tw-gap-4 tw-px-4 tw-py-6 tw-text-left"
                  >
                    <h4 class="tw-mb-2 tw-line-clamp-2 tw-h-16 tw-overflow-hidden" style="color: var(--c-text_primary)">
                      {{ guide.title }}
                    </h4>
                    <h6 style="color: var(--c-secondary)">VIEW THIS GUIDE</h6>
                  </div>
                </div>
              </MotionGroup>
            </SwiperSlide>
          </Swiper>
          <!-- Slider Pagination (mobil versiyon için) -->
          <div class="controls">
            <div
              data-w-id="080a9ca2-7a2d-2ca3-3b22-f42b27569daf"
              class="slide-left-arrow w-slider-arrow-left"
              :isDisabled="!canPaginateBack"
              @click="() => swiper.slidePrev()"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M16.011 3.49956C16.1418 3.6335 16.2151 3.81332 16.2151 4.00056C16.2151 4.18781 16.1418 4.36762 16.011 4.50156L8.70149 12.0001L16.011 19.4971C16.1418 19.631 16.2151 19.8108 16.2151 19.9981C16.2151 20.1853 16.1418 20.3651 16.011 20.4991C15.9474 20.5644 15.8714 20.6163 15.7874 20.6517C15.7034 20.6872 15.6132 20.7054 15.522 20.7054C15.4308 20.7054 15.3406 20.6872 15.2566 20.6517C15.1726 20.6163 15.0966 20.5644 15.033 20.4991L7.25999 12.5236C7.12347 12.3835 7.04706 12.1957 7.04706 12.0001C7.04706 11.8045 7.12347 11.6166 7.25999 11.4766L15.033 3.50106C15.0966 3.43575 15.1726 3.38383 15.2566 3.34839C15.3406 3.31294 15.4308 3.29468 15.522 3.29468C15.6132 3.29468 15.7034 3.31294 15.7874 3.34839C15.8714 3.38383 15.9474 3.43575 16.011 3.50106V3.49956Z"
                  fill="#6EADAB"
                />
              </svg>
              <div class="slide-circle slider-circle-transform"></div>
            </div>
            <div
              data-w-id="080a9ca2-7a2d-2ca3-3b22-f42b27569db1"
              class="slide-right-arrow w-slider-arrow-right"
              :isDisabled="!canPaginateNext"
              @click="() => swiper.slideNext()"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7.98901 3.49956C7.85817 3.6335 7.78491 3.81332 7.78491 4.00056C7.78491 4.18781 7.85817 4.36762 7.98901 4.50156L15.2985 12.0001L7.98901 19.4971C7.85817 19.631 7.78491 19.8108 7.78491 19.9981C7.78491 20.1853 7.85817 20.3651 7.98901 20.4991C8.0526 20.5644 8.12864 20.6163 8.21263 20.6517C8.29661 20.6872 8.38685 20.7054 8.47801 20.7054C8.56917 20.7054 8.65941 20.6872 8.74339 20.6517C8.82738 20.6163 8.90342 20.5644 8.96701 20.4991L16.74 12.5236C16.8765 12.3835 16.9529 12.1957 16.9529 12.0001C16.9529 11.8045 16.8765 11.6166 16.74 11.4766L8.96701 3.50106C8.90342 3.43575 8.82738 3.38383 8.74339 3.34839C8.65941 3.31294 8.56917 3.29468 8.47801 3.29468C8.38685 3.29468 8.29661 3.31294 8.21263 3.34839C8.12864 3.38383 8.0526 3.43575 7.98901 3.50106V3.49956Z"
                  fill="#6EADAB"
                />
              </svg>
              <div class="slide-circle right"></div>
            </div>
          </div>
        </div>
      </div>
      <MotionGroup is="div" preset="popVisible" :duration="500">
        <popup v-if="selectedGuide && popupConfig.isActive" :config="popupConfig" custom-width="90%">
          <template #content>
            <div class="tw-w-full" style="background-color: var(--c-section_tertiary)">
              <div
                class="tw-mx-auto tw-flex tw-w-full tw-flex-col md:tw-w-[80%] lg:tw-w-full lg:tw-flex-row"
                style="border-radius: var(--rounded)"
              >
                <div class="tw-w-full tw-overflow-hidden lg:tw-max-w-[465px]" style="border-radius: var(--rounded)">
                  <LibraryImage
                    :w-ratio="1"
                    :h-ratio="1.5"
                    :src="selectedGuide.photo || selectedGuide.popup_cover"
                    style="border-radius: var(--rounded)"
                  />
                </div>
                <div class="tw-flex tw-w-full tw-py-6 md:tw-py-10 lg:tw-px-10 lg:tw-py-0 xl:tw-px-20">
                  <h2 style="color: var(--c-text_primary)">{{ selectedGuide.popup_title }}</h2>
                  <!-- form alanı -->
                  <library-form
                    v-if="selectedGuide.guide"
                    :form="form"
                    version="v2"
                    :component="component"
                    :custom-managed-form="managedFormVars"
                  ></library-form>
                </div>
              </div>
            </div>
          </template>
        </popup>
      </MotionGroup>
    </section>
  </template>

  <template v-else-if="sidebarComponents.length > 0">
    <div v-if="variants.v1 === variant">
      <div class="tw-w-full tw-px-7 tw-py-12">
        <div class="tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center tw-gap-7">
          <div class="md:tw-w-full">
            <div
              class="tw-mb-5 tw-flex tw-w-[98%] tw-flex-row tw-flex-wrap tw-items-center tw-justify-between tw-gap-y-2 md:tw-mb-8"
            >
              <div v-html="vars.titleHtml" class="tw-flex tw-flex-row tw-flex-wrap tw-gap-x-4 tw-text-black"></div>
              <nuxt-link
                v-if="vars.buttonTypeText"
                :to="vars.buttonLinkUrl"
                :class="`n-${vars.buttonTypeText} tw-hidden lg:tw-block`"
                :external="true"
              >
                {{ vars.buttonLabelText }}</nuxt-link
              >
            </div>
            <Swiper
              effect="fade"
              :clickable="true"
              :loop="true"
              :modules="[SwiperGrid]"
              :watch-overflow="true"
              @slideChange="onSlideChange"
              :breakpoints="{
                320: {
                  slidesPerView: 1,
                },
              }"
              :spaceBetween="10"
              @swiper="onSwiper"
              class="tw-max-w-xs md:tw-max-w-none"
            >
              <SwiperSlide
                v-for="(guide, index) in guides"
                :key="`ourguide-guide-${index}`"
                class="!tw-flex !tw-h-auto tw-max-w-none tw-items-center tw-justify-center tw-px-2"
              >
                <guide-card :component="component" :guide="guide" />
              </SwiperSlide>
              <div v-if="guides.length > 1" class="controls !tw-mt-8">
                <div
                  data-w-id="080a9ca2-7a2d-2ca3-3b22-f42b27569daf"
                  class="slide-left-arrow w-slider-arrow-left"
                  :isDisabled="!canPaginateBack"
                  @click="() => swiper.slidePrev()"
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M16.011 3.49956C16.1418 3.6335 16.2151 3.81332 16.2151 4.00056C16.2151 4.18781 16.1418 4.36762 16.011 4.50156L8.70149 12.0001L16.011 19.4971C16.1418 19.631 16.2151 19.8108 16.2151 19.9981C16.2151 20.1853 16.1418 20.3651 16.011 20.4991C15.9474 20.5644 15.8714 20.6163 15.7874 20.6517C15.7034 20.6872 15.6132 20.7054 15.522 20.7054C15.4308 20.7054 15.3406 20.6872 15.2566 20.6517C15.1726 20.6163 15.0966 20.5644 15.033 20.4991L7.25999 12.5236C7.12347 12.3835 7.04706 12.1957 7.04706 12.0001C7.04706 11.8045 7.12347 11.6166 7.25999 11.4766L15.033 3.50106C15.0966 3.43575 15.1726 3.38383 15.2566 3.34839C15.3406 3.31294 15.4308 3.29468 15.522 3.29468C15.6132 3.29468 15.7034 3.31294 15.7874 3.34839C15.8714 3.38383 15.9474 3.43575 16.011 3.50106V3.49956Z"
                      fill="#6EADAB"
                    />
                  </svg>
                  <div class="slide-circle slider-circle-transform"></div>
                </div>
                <div
                  data-w-id="080a9ca2-7a2d-2ca3-3b22-f42b27569db1"
                  class="slide-right-arrow w-slider-arrow-right"
                  :isDisabled="!canPaginateNext"
                  @click="() => swiper.slideNext()"
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M7.98901 3.49956C7.85817 3.6335 7.78491 3.81332 7.78491 4.00056C7.78491 4.18781 7.85817 4.36762 7.98901 4.50156L15.2985 12.0001L7.98901 19.4971C7.85817 19.631 7.78491 19.8108 7.78491 19.9981C7.78491 20.1853 7.85817 20.3651 7.98901 20.4991C8.0526 20.5644 8.12864 20.6163 8.21263 20.6517C8.29661 20.6872 8.38685 20.7054 8.47801 20.7054C8.56917 20.7054 8.65941 20.6872 8.74339 20.6517C8.82738 20.6163 8.90342 20.5644 8.96701 20.4991L16.74 12.5236C16.8765 12.3835 16.9529 12.1957 16.9529 12.0001C16.9529 11.8045 16.8765 11.6166 16.74 11.4766L8.96701 3.50106C8.90342 3.43575 8.82738 3.38383 8.74339 3.34839C8.65941 3.31294 8.56917 3.29468 8.47801 3.29468C8.38685 3.29468 8.29661 3.31294 8.21263 3.34839C8.12864 3.38383 8.0526 3.43575 7.98901 3.50106V3.49956Z"
                      fill="#6EADAB"
                    />
                  </svg>
                  <div class="slide-circle right"></div>
                </div>
              </div>
            </Swiper>
          </div>
          <nuxt-link
            v-if="vars.buttonTypeText"
            :to="vars.buttonLinkUrl"
            :class="`n-${vars.buttonTypeText} lg:tw-hidden`"
            :external="true"
          >
            {{ vars.buttonLabelText }}</nuxt-link
          >
        </div>
      </div>
    </div>

    <div
      v-else-if="variants.v2 === variant"
      :style="`background-color: var(--c-${vars.backgroundColor}); border-radius: var(--rounded)`"
      class="tw-p-6"
    >
      <div class="tw-flex tw-w-full tw-flex-col tw-items-center">
        <!-- Başlık -->
        <div v-html="vars.titleHtml" class="tw-mb-6 tw-w-full tw-text-start"></div>
        <!-- Mobil ve Tablet Görünümü: Swiper Slider -->
        <div class="tw-w-full">
          <Swiper
            @swiper="onSwiper"
            @slideChange="onSlideChange"
            :pagination="false"
            :slides-per-view="1"
            :space-between="24"
            :clickable="true"
            class="tw-w-full"
          >
            <SwiperSlide v-for="(guide, index) in guides" :key="`ourguide-guide-${index}`" class="!tw-flex !tw-h-auto">
              <div
                class="n-card tw-group tw-relative tw-flex tw-min-h-[600px] tw-w-full tw-cursor-pointer tw-flex-col tw-overflow-hidden tw-rounded-[var(--c-rounded)] tw-bg-[var(--c-input)] tw-text-start tw-transition-all tw-duration-500 hover:tw-bg-white"
                @click="handleGuideClick(guide)"
                style="border-radius: var(--rounded)"
              >
                <!-- Resim Alanı -->
                <div class="tw-relative">
                  <div class="tw-relative tw-p-4">
                    <library-image
                      v-if="guide.photo"
                      :src="guide.photo"
                      :is-ratio-free="true"
                      image-class="tw-h-full tw-w-full tw-object-cover"
                      style="border-radius: var(--rounded)"
                    />
                  </div>
                </div>
                <!-- Kart Bilgi Alanı: Başlık ve Buton -->
                <div
                  class="tw-flex tw-h-full tw-flex-col tw-items-start tw-justify-end tw-gap-4 tw-px-4 tw-py-6 tw-text-left"
                >
                  <h5 class="tw-mb-2 tw-line-clamp-2 tw-h-20 tw-overflow-hidden tw-text-[--c-secondary]">
                    {{ guide.title }}
                  </h5>
                  <nuxt-link
                    :to="guide.button_link ? guide.button_link : ''"
                    :external="true"
                    target="_blank"
                    class="n-secondary n-link"
                    @click.prevent="!guide.button_link && handleGuideClick(guide)"
                  >
                    VIEW THIS GUIDE
                  </nuxt-link>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
          <!-- Slider Pagination (mobil versiyon için) -->
          <div class="tw-mt-10">
            <LibrarySliderPagination
              :swiper="swiper"
              variant="v6"
              :canPaginateBack="canPaginateBack"
              :canPaginateNext="canPaginateNext"
            />
          </div>
        </div>
      </div>
    </div>

    <popup v-if="selectedGuide && popupConfig.isActive" :config="popupConfig" custom-width="90%">
      <template #content>
        <div class="tw-w-full tw-bg-white">
          <div
            class="tw-mx-auto tw-flex tw-w-full tw-flex-col md:tw-w-[80%] lg:tw-w-full lg:tw-flex-row"
            style="border-radius: var(--rounded)"
          >
            <div class="tw-w-full tw-overflow-hidden lg:tw-max-w-[465px]" style="border-radius: var(--rounded)">
              <LibraryImage
                :w-ratio="1"
                :h-ratio="1.5"
                :src="selectedGuide.photo || selectedGuide.popup_cover"
                style="border-radius: var(--rounded)"
              />
            </div>
            <div class="tw-flex tw-w-full tw-py-6 md:tw-py-10 lg:tw-px-10 lg:tw-py-0 xl:tw-px-20">
              <h2 class="n-title-primary">{{ selectedGuide.popup_title }}</h2>
              <!-- form alanı -->
              <library-form v-if="selectedGuide.guide" :form="form" version="v2" :component="component"></library-form>
            </div>
          </div>
        </div>
      </template>
    </popup>
  </template>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import { ComponentMixin } from '~/mixins/component.mixin';
import GuideCard from './GuideCard.vue';
import { useWebsiteStore } from '~/units/website/store';
import Popup from '~/components/common/popup/Popup.vue';

export default defineNuxtComponent({
  name: 'OurGuide',

  mixins: [ComponentMixin],

  components: { GuideCard, Popup },

  data() {
    return {
      swiper: null,
      canPaginateBack: true,
      canPaginateNext: true,
      selectedGuide: null as any,
      form: null,
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
      },
      popupConfig: {
        isActive: false,
      },
    };
  },

  computed: {
    ...mapState(useWebsiteStore, ['sidebarComponents']),
    guides() {
      return this.groupedVariables.guides;
    },

    ...mapState(useWebsiteStore, ['sidebarComponents']),

    managedFormVars() {
      return {
        isNeuronManagedFormBool: this.selectedGuide.is_neuron_managed_form,
        formRedirectUrlText: this.selectedGuide.form_redirect_url,
        formInternalTitleForCustomerText: this.selectedGuide.form_internal_title_for_customer,
      };
    },
  },

  methods: {
    onSwiper(swiper) {
      this.swiper = swiper;
    },

    onSlideChange() {
      if (!this.swiper) return;
      const isAtStart = this.swiper.isBeginning;
      const isAtEnd = this.swiper.isEnd;
      if (isAtStart) this.canPaginateBack = false;
      else this.canPaginateBack = true;
      if (isAtEnd) this.canPaginateNext = false;
      else this.canPaginateNext = true;
    },
    handleGuideClick(guide) {
      if (guide.guide) {
        this.form = this.parseFormV2(guide.guide);
        this.toggleGuidePopup(guide, true);
      } else if (guide.button_link) {
        this.$router.push(guide.button_link);
      }
    },
    toggleGuidePopup(guide = null, value = false) {
      this.selectedGuide = guide;
      this.popupConfig.isActive = value;
    },
  },

  mounted() {
    this.onSlideChange();
  },
});
</script>
